import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TabsV2 from '../../Components/common/Tabs/TabsV2';
import classes from './Settings.module.scss';
import EmailNotifications from '../../Components/pages/EmailNotifications/EmailNotifications';
import { getAllJobAlerts } from '../../actions/jobAlerts';

const tabs = {
  ACC_SETTINGS: 'accountsettings',
  EMAIL_NOTIFICATIONS: 'emailnotifications'
};

const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const alertsActiveStatus = useSelector((state) => state.jobAlerts.isActive);
  const jobAlertList = useSelector((state) => state.jobAlerts.alerts);
  const cardStyleFade = useSelector((state) => state.jobAlerts.cardStyleFade);

  const baseTabs = [
    // TODO uncomment when you are gonna work on this functionality
    // {
    //   title: t('dashboard.settings.accountsettings'),
    //   value: tabs.ACC_SETTINGS
    // },
    {
      title: t('dashboard.settings.emailnotifications'),
      value: tabs.EMAIL_NOTIFICATIONS
    }
  ];

  // TODO default value should be ACC_SETTINGS change it when you are gonna work on this functionality
  const [selectedTab, setSelectedTab] = useState(searchParams.get('tab') || tabs.EMAIL_NOTIFICATIONS);

  const changeTab = (tabDetails) => {
    setSelectedTab(tabDetails.value);
    setSearchParams({ tab: tabDetails.value });
  };

  useEffect(() => {
    dispatch(getAllJobAlerts());
  }, []);

  const renderTabContent = () => {
    switch (selectedTab) {
      case tabs.ACC_SETTINGS:
        return <h4>Coming soon....</h4>;
      case tabs.EMAIL_NOTIFICATIONS:
        return (
          <EmailNotifications
            alertsActiveStatus={alertsActiveStatus}
            jobAlertList={jobAlertList}
            cardStyleFade={cardStyleFade}
          />
        );
      default:
        return tabs.ACC_SETTINGS;
    }
  };

  return (
    <section className={classes.pageWrapper}>
      <div className={classes.mainSection}>
        <TabsV2 tabs={baseTabs} currentTab={selectedTab} setTab={changeTab} />
        {renderTabContent()}
      </div>
    </section>
  );
};

export default Settings;
